const Title = () => {
  return (
    <div className="flex w-full items-center justify-center text-center">
      <p className="-mt-10 h-0 font-bold text-3xl sm:mt-0 sm:h-10 sm:text-6xl">
        <span className="bg-linear-to-r from-purple-100 to-blue-400 bg-clip-text text-3xl text-transparent sm:h-20 sm:text-6xl">
          Choose the plan
        </span>
        &nbsp;that fits your needs
      </p>
    </div>
  );
};

export default Title;
